/* payment/commonview/lib/view-binaryquestion.js */

/* This is an updated extraction of the notifications module to be loaded using commonJS */
import core from '../../common/lib/core.js';

const elements = {};
let removeListeners = null;
let confirmationCallback = null;
let rejectionCallback = null;
let confirmButtonText;
let rejectButtonText;
let messageText;
let messageTitle;

function selectElements() {
	elements.wrap = (elements.wrap || document.querySelector('.js-global-notification')); /* this wrapper is put into below the #container div and in one occurence per casino, shop and ... */
	elements.wrapSubContent = (elements.wrapSubContent || elements.wrap.querySelector('.js-binary-question'));
	elements.mainTitle = (elements.mainTitle || elements.wrapSubContent.querySelector('.js-title'));
	elements.text = (elements.text || elements.wrapSubContent.querySelector('.js-text'));
	elements.btnYes = (elements.btnYes || elements.wrapSubContent.querySelector('.js-button-wrap-yes'));
	elements.btnNo = (elements.btnNo || elements.wrapSubContent.querySelector('.js-button-wrap-no'));
}

function setTexts() {
	elements.btnYes.innerHTML = confirmButtonText;
	elements.btnNo.innerHTML = rejectButtonText;
	elements.mainTitle.innerHTML = messageTitle;
	elements.text.innerHTML = messageText;
}

function openWrappers() {
	core.addClass(elements.wrap, 'global-notification--is-open');
	core.addClass(elements.wrapSubContent, 'notify--is-open');
}

function closeWrappers() {
	core.removeClass(elements.wrap, 'global-notification--is-open');
	core.removeClass(elements.wrapSubContent, 'notify--is-open');
}

function close() {
	removeListeners();
	closeWrappers();
}

function clickNoHandler() {
	close();
	rejectionCallback();
}

function clickYesHandler() {
	close();
	confirmationCallback();
}

function addListeners() {
	elements.btnNo.addEventListener('click', clickNoHandler);
	elements.btnYes.addEventListener('click', clickYesHandler);
}
/* this function is stored with a name different from the containing variable,
to solve the 'no-shadow' and the 'no use before define' linting rules.
*/
removeListeners = function removeListenersFkn() {
	if (elements && elements.btnNo) {
		elements.btnNo.removeEventListener('click', clickNoHandler);
	}
	if (elements && elements.btnYes) {
		elements.btnYes.removeEventListener('click', clickYesHandler);
	}
};

export default {
	show(msgTxt, confirmTxt, rejectTxt, confirmCb, rejectCb, msgTitle = '') {
		confirmationCallback = (confirmCb || function empty() {});
		rejectionCallback = (rejectCb || function empty() {});
		messageTitle = msgTitle;
		messageText = (msgTxt || 'Continue?');
		confirmButtonText = (confirmTxt || 'Yes');
		rejectButtonText = (rejectTxt || 'No');
		selectElements();
		setTexts();
		addListeners();
		openWrappers();
	},
	close() {
		close();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/commonview/lib/view-binaryquestion.js